import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Drag",
  "use": "icon-Drag-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Drag\">\n<g clip-path=\"url(#icon-Drag_clip0_11072_169741)\">\n<path d=\"M19 16H1V14H19V16ZM19 11H1V9H19V11ZM19 6H1V4H19V6Z\" fill=\"#314455\" />\n</g>\n<defs>\n<clipPath id=\"icon-Drag_clip0_11072_169741\">\n<rect width=\"20\" height=\"20\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/Drag.svg
// module id = DGN9
// module chunks = 262